export enum CasAsOfMode {
  ViewEdit = 'ViewEdit',
  NewEntity = 'NewEntity',
  NewAsOf = 'NewAsOf',
}
